
var id = "lishichaxunjilu";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 792 792\" id=\"lishichaxunjilu\">\n<style type=\"text/css\">\n\t#lishichaxunjilu .st0{clip-path:url(#lishichaxunjilu_SVGID_2_);}\n</style>\n<g>\n\t<g>\n\t\t<defs>\n\t\t\t<rect id=\"lishichaxunjilu_SVGID_1_\" y=\"36.62\" width=\"791.76\" height=\"717.84\" />\n\t\t</defs>\n\t\t<clipPath id=\"lishichaxunjilu_SVGID_2_\">\n\t\t\t<use xlink:href=\"#lishichaxunjilu_SVGID_1_\" style=\"overflow:visible;\" />\n\t\t</clipPath>\n\t\t<path class=\"st0\" d=\"M783.36,292.7c-10.24-10.24-25.6-10.24-35.84,0l-35.84,35.84C680.96,159.58,537.6,36.7,358.4,36.7\n\t\t\tC158.72,36.7,0,195.42,0,395.1c0,199.68,158.72,358.4,358.4,358.4c92.16,0,174.08-35.84,235.52-87.04\n\t\t\tc5.12-5.12,10.24-10.24,10.24-20.48c0-15.36-10.24-25.6-25.6-25.6c-5.12,0-15.36,5.12-20.48,10.24v-5.12\n\t\t\tc-56.32,46.08-122.88,76.8-199.68,76.8c-168.96,0-307.2-138.24-307.2-307.2c0-168.96,138.24-307.2,307.2-307.2\n\t\t\tc163.84,0,296.96,128,307.2,286.72l-87.04-87.04c-10.24-10.24-25.6-10.24-35.84,0c-10.24,10.24-10.24,25.6,0,35.84l102.4,102.4\n\t\t\tc10.24,10.24,25.6,10.24,35.84,0l102.4-102.4C793.6,318.3,793.6,302.94,783.36,292.7L783.36,292.7z M783.36,292.7\" />\n\t</g>\n\t<path d=\"M358.4,190.3c-15.36,0-25.6,10.24-25.6,25.6v204.8c0,5.12,0,10.24,5.12,15.36v5.12l92.16,92.16\n\t\tc10.24,10.24,25.6,10.24,35.84,0c10.24-10.24,10.24-25.6,0-35.84L384,415.58V215.9C384,200.54,373.76,190.3,358.4,190.3\n\t\tL358.4,190.3z M358.4,190.3\" />\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
